module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#strategy",
      toString: function () {
        return this.url;
      }
    }